module.exports = {
  default: {
    // is_filter: 1,
    // is_show: 1,
    is_needed: 1, // 是否必填
    name: '', // 字段名
    sort: 0,  // 排序
    tips: '', // 提示语
    title: '',  // 字段标题
    type: ''  // 控件类型
  },
  selected: false
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/index.js